import { useEffect, useState } from 'react'
import './Cookie.css'

function Cookies() {
    const [showCookiesMess, setShowCookiesMess] = useState(true)

    // see if cookie already exists
    useEffect(() => {
        let isCookiesApproved = localStorage.getItem("cookiesApproved")
        isCookiesApproved = JSON.parse(isCookiesApproved)
        if (isCookiesApproved) setShowCookiesMess(false)
    }, [])

    const approveCookies = () => {
        localStorage.setItem("cookiesApproved", true)
        setShowCookiesMess(false)
    }

    const disagreeCookies = () => {
        setShowCookiesMess(false)
    }

    return (
        <>
            {showCookiesMess ?
                <div className="cookieBox">
                    Vi vill spara cookies på din enhet för att förbättra din upplevelse av sidan. &nbsp;
                    <button
                        onClick={approveCookies}
                    >
                        Godkänn
                    </button>
                    <button
                        onClick={disagreeCookies}
                        className="disagree"
                    >
                        Neka
                    </button>
                </div>
            :
                null
            }
        </>
    )
}

export default Cookies